export default __webpack_public_path__ + "static/media/2930 spice rack D side.eaa07f3e.png";